import { svg } from "../svg";

const BitwardenShield = svg`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 32" fill="none">
    <rect x="0" y="3" width="26" height="26" rx="7" fill="#0066ff"/>
    <path d="M9 14.3v-1.5a4 4 0 0 1 8 0v1.5" fill="none" stroke="#ffffff" stroke-width="1.8" stroke-linecap="round"/>
    <rect x="7.5" y="14" width="11" height="9.5" rx="2" fill="#ffffff"/>
    <circle cx="13" cy="18.6" r="1.2" fill="#0066ff"/>
  </svg>
`;

export { BitwardenShield };
